import type { ContentAssetType } from './types';

export type ContentTypeWire =
  | 'whitepaper'
  | 'ebook'
  | 'case_study'
  | 'video'
  | 'display_banner'
  | 'email_template'
  | 'landing_page'
  | 'infographic'
  | 'other';

export const ASSET_TYPE_TO_WIRE: Record<ContentAssetType, ContentTypeWire> = {
  WP: 'whitepaper',
  EB: 'ebook',
  CS: 'case_study',
  VID: 'video',
  BN: 'display_banner',
  EM: 'email_template',
  LP: 'landing_page',
  IG: 'infographic',
  OT: 'other',
};

export const WIRE_TO_ASSET_TYPE: Record<ContentTypeWire, ContentAssetType> = {
  whitepaper: 'WP',
  ebook: 'EB',
  case_study: 'CS',
  video: 'VID',
  display_banner: 'BN',
  email_template: 'EM',
  landing_page: 'LP',
  infographic: 'IG',
  other: 'OT',
};

interface AssetTypeMeta {
  code: ContentAssetType;
  label: string;
  short: string;
  color: string;
}

export const ASSET_TYPES: AssetTypeMeta[] = [
  { code: 'WP', label: 'Whitepaper', short: 'WP', color: 'var(--dz-blue-muted)' },
  { code: 'EB', label: 'Ebook / Guide', short: 'EB', color: 'var(--dz-blue-muted)' },
  { code: 'CS', label: 'Case Study', short: 'CS', color: 'var(--dz-blue-muted)' },
  { code: 'VID', label: 'Video', short: 'VID', color: 'var(--dz-charcoal)' },
  { code: 'BN', label: 'Display Banner', short: 'BN', color: 'var(--dz-bright-blue)' },
  { code: 'EM', label: 'Email Template', short: 'EM', color: 'var(--dz-link-blue)' },
  { code: 'LP', label: 'Landing Page', short: 'LP', color: 'var(--dz-success)' },
  // Peach shade (TC1) — the palette's dark amber. Was a raw `#B45309` literal
  // written before the 3rd Eye tonal families existed.
  { code: 'IG', label: 'Infographic', short: 'IG', color: 'var(--dz-tone-peach-fg)' },
  { code: 'OT', label: 'Other', short: '—', color: 'var(--dz-muted)' },
];

export const ASSET_TYPE_SELECT_OPTIONS = ASSET_TYPES.map((t) => ({
  value: t.code,
  label: t.label,
}));

export const getAssetTypeColor = (code: ContentAssetType): string =>
  ASSET_TYPES.find((t) => t.code === code)?.color ?? 'var(--dz-muted)';

export const getAssetTypeShort = (code: ContentAssetType): string =>
  ASSET_TYPES.find((t) => t.code === code)?.short ?? code;

export const getAssetTypeLabel = (code: ContentAssetType): string =>
  ASSET_TYPES.find((t) => t.code === code)?.label ?? code;
